import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // Check your custom authentication logic here
        const isAuthenticated = this.checkAuthentication();

        if (isAuthenticated) {
            return true;
        }

        // Not authenticated, redirect to the login page with the return URL
        this.router.navigate(['/account/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }

    private checkAuthentication(): boolean {
        // Implement your custom authentication logic here
        // For example, you can check if the user is logged in using cookies, tokens, or any other method.
        // Return true if authenticated, false otherwise.
        return true; // Modify this based on your logic
    }
}
